<template lang="pug">
  div.kids-subject
    div.scroller-outter
      div.theme-title
        h3 New Arrivals
        p.intro The newly-arrived spring collection is made to keep your kiddos fresh in the new year.
        div.shop-now
          a(href="shopLink") Shop Now
      div.list-out-wrapper
        div.list-wrapper.scroller-inner(ref="scroller")
          ul.list
            li.inner-theme-title
              h3 New Arrivals
              p.intro The newly-arrived spring collection is made to keep your kiddos fresh in the new year.
              div.shop-now
                a(href="shopLink") Shop Now
            SaleThemeItem(v-for="(item,$index) in [1,2,3,4,5,6,7,8,9,10]", :key="item")
    div.scroller(ref="scrollerIndicator")
      div.scroller-indicator(:style="`width:${indicatorWidth}px;left:${left}px;`")

</template>
<script>
import SaleThemeItem from '@/components/SaleThemeItem.vue'
export default {
  name: 'KidsSubject',
  data () {
    return {
      left: 0,
      indicatorWidth: 0,
      scrollerIndicatorWidth: 0
    }
  },
  created () {

  },
  mounted () {
    let scrollerIndicatorWidth = this.$refs.scrollerIndicator.clientWidth
    this.scrollerIndicatorWidth = scrollerIndicatorWidth
    let clientWidth = this.$refs.scroller.clientWidth
    let scrollWidth = this.$refs.scroller.scrollWidth
    let indicatorWidth = clientWidth / scrollWidth * scrollerIndicatorWidth
    this.indicatorWidth = indicatorWidth
    this.$refs.scroller.addEventListener('scroll', (e) => {
      let scrollLeft = e.target.scrollLeft
      let percent = scrollLeft / (scrollWidth - clientWidth)
      let left = (scrollerIndicatorWidth - indicatorWidth) * percent
      this.left = left
    })
  },
  components: {
    SaleThemeItem
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/common.scss";
.kids-subject  {
  padding-top: 3.125rem;
  margin-bottom: 3.125rem;
}

.theme-title {
  display: block;
  width: 90vw;
  margin: 10vw auto;
}

.theme-title h3 {
  font-family: akzidenz-grotesk-condensed,Arial Narrow,Arial,sans-serif;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 24px;
  font-size: 1.5rem;
  line-height: 30px;
  line-height: 1.875rem;
  letter-spacing: 1px;
  color: #1a1a1a;
  text-align: center;
}
.intro {
  width: 70%;
  margin: 1rem auto;
  text-align: center;
}
.shop-now  {
  text-align: center;
  a {
    @extend %button;
  }
}

.list-wrapper {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  margin: 1rem 0;
}
.list-wrapper::-webkit-scrollbar {
  display: none;
}
.list  {
  list-style: none;
  display: flex;
  white-space: nowrap;
}

.sale-theme-item {
  width: 65vw;
  padding: 0 1.875rem .625rem 0;
  flex-shrink: 0;
}

.scroller {
  width: 100%;
  height: 21px;
  background: #f55;
  width: 80vw;
  margin: 0 auto;
}

.inner-theme-title {
  display: none;
  width: 40vw;
  height: 100%;
  white-space: normal;
  margin-bottom: 1.875rem;
  padding-left: 10vw;
  padding-right: 1.25rem;
  flex-shrink: 0;
  h3 {
    font-family: akzidenz-grotesk-condensed,Arial Narrow,Arial,sans-serif;
    font-weight: 400;
    text-transform: uppercase;
    font-size: 24px;
    font-size: 1.5rem;
    line-height: 30px;
    line-height: 1.875rem;
    letter-spacing: 1px;
    color: #1a1a1a;
    text-align: left;
  }
  .intro {
    width: 70%;
    margin: 1rem 0;
    text-align: left;
  }
  .shop-now  {
    text-align: left;
  }
}
.scroller {
  position: relative;
}

.scroller-indicator {
  position: absolute;
  left: 0;
  height: 100%;
  background: #f5f;
}

@media only screen and (max-width: 959px) {

}

@media only screen and (min-width: 768px) {
  .inner-theme-title {
    display: block;
  }

  .theme-title {
    width: 45vw;
    flex-shrink: 0;
    display: none;
  }
}

@media only screen and (min-width: 480px){
  .sale-theme-item  {
      width: 38vw;
  }
}

@media only screen and (min-width: 768px) {
  .sale-theme-item {
    width: 33vw;
    padding-right: 2.5rem;
  }
}

@media only screen and (min-width: 960px) {
  .sale-theme-item {
    width: 25vw;
  }
}

@media only screen and (min-width: 1200px) {
  .sale-theme-item {
      width: 18vw;
  }
}
</style>
